import block from './block.json';

export const mainNavThemeAttributes = {
	height: [115, 134],
	padding: {
		top: [15, 18],
		bottom: [15, 18],
	},
	logo: {
		width: [100, 120],
	},
	cart: {
		typography: {
			fontFamily: '@tokens.fonts.secondary.fontFamily',
			fontSize: [11, 11],
			fontWeight: 600,
			letterSpacing: [0, 0],
			color: '@tokens.variants.default.contentColor',
		},
		backgroundColor: '#FFE772',
	},
	desktop: {
		primary: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.heading-4',
			textAlignment: 'left',
			grid: {
				gap: [20, 25],
			},
		},
		secondary: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.text-s-medium',
			textAlignment: 'left',
			grid: {
				gap: [15, 20],
			},
		},
		submenu: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.caption',
			textAlignment: 'left',
		},
	},
	mobile: {
		hamburger: {
			color: '@tokens.variants.default.contentColor',
			width: '26px',
			height: '17px',
		},
		primary: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.heading-2',
			textAlignment: 'left',
			submenu: {
				color: '@tokens.variants.default.contentColor',
				typography: '@tokens.typographies.small-text',
				textAlignment: 'left',
			},
		},
		secondary: {
			color: '@tokens.variants.default.contentColor',
			typography: '@tokens.typographies.text-s-medium',
			textAlignment: 'left',
		},
	},
	states: {
		active: {}, // adds active state
	},
};

export const MainNavThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: mainNavThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
